;(function($) {


    //-----------------------------------------------------------------//
    // TOUCH DETECT
    //-----------------------------------------------------------------//
    window.is_touch_device = function () {
        try {
            document.createEvent("TouchEvent");
            return true;
        } catch (e) {
            return false;
        }
    }

    if (is_touch_device()) {
        document.documentElement.classList.add('touch');
    } else {
        document.documentElement.classList.add('no-touch');
    }

    //-----------------------------------------------------------------//
    // Global detect if mouse down to handle some conflicts with focus
    //-----------------------------------------------------------------//
    var mouseDown = 0;
    document.body.onmousedown = function() {
        ++mouseDown;
    }
    document.body.onmouseup = function() {
        --mouseDown;
    }

    //-----------------------------------------------------------------//
    // Tabindex fix on popups
    //-----------------------------------------------------------------//
    $(document).on('DOMNodeInserted', function(e) {
        if ( $(e.target).hasClass('dialog-widget') ) {
            $(e.target).find('.dialog-message').attr('tabindex',0);
        }

    });
    var overlayFocused = false;
    $(document).keydown(function(e) {
        var key = (event.keyCode ? event.keyCode : event.which);
        if (key === 27) { // Escape key removes focus
            $(document.activeElement).blur();
        }
        if (key === 9) { // Tab key
            if(
                $('.elementor-popup-modal').length &&
                $('.elementor-popup-modal').attr('style') !== 'display: none;')
            {
                setTimeout(function(){
                    if($(':focus').parents('.elementor-popup-modal').length > 0) {
                    } else {
                        $('.elementor-popup-modal').find('.dialog-message').focus();
                    }
                }, 10);
                if(!overlayFocused) {
                    $('.elementor-popup-modal').find('.dialog-message').focus();
                    overlayFocused = true;
                }
            } else {
                overlayFocused = false;
            }
        }
    });


    //-----------------------------------------------------------------//
    // Jump to content section from tab
    //-----------------------------------------------------------------//
    $('.jump-to-content-button a').on('click', function(e) {
        var link = $(this).attr('href');
        if(!$(link).length) link = 'main';

        $("html, body").animate({ scrollTop: $(link).offset().top });
        $(link).attr('tabindex','0');
        $(link).focus();

        return false;
    });


    //-----------------------------------------------------------------//
    // Open Elementor nav menu on tabindex
    //-----------------------------------------------------------------//
    $(document).on('focusin', '.elementor-widget-nav-menu', function(){
        if(mouseDown) return;

        var el = $(this);

        if(!el.find('.elementor-menu-toggle').hasClass('elementor-active')){
            el.find('.elementor-menu-toggle').addClass('elementor-active');
        }
    });

    $(document).on('focusout', '.elementor-widget-nav-menu', function(){
        if(mouseDown) return;

        var el = $(this);

        if(el.find('.elementor-menu-toggle').hasClass('elementor-active')){
            el.find('.elementor-menu-toggle').removeClass('elementor-active');
        }
    });


    //-----------------------------------------------------------------//
    // Tab index on Jet menus
    //-----------------------------------------------------------------//
    $(document).on('focusin', '.jet-menu-item-has-children', function(){
        var el = $(this);
        el.addClass('jet-menu-hover');
    });

    $(document).on('focusout', '.jet-menu-item-has-children', function(){
        var el = $(this);
        el.removeClass('jet-menu-hover');
    });

    // Add tab index to mega menus
    $('.elementor-widget-jet-mega-menu').each(function(){
        var el = $(this);
        el.find('.jet-menu-item.jet-menu-item-has-children').attr('tabindex',0);
    });

    //-----------------------------------------------------------------//
    // Tab index on Jet Filters
    //-----------------------------------------------------------------//
    // Checkboxes
    $('.jet-checkboxes-list').each(function(){
        $(this).find('label.jet-checkboxes-list__item').each(function(){
            var label = $(this);
            label.attr('tabindex',0);



            label.on('keypress', function (event) {
                if (event.keyCode == 13) {
                    label.trigger('click');
                }
            });
        });
    });
    // Select
    $('.jet-select').each(function(){
        var select = $(this).find('select');
        select.attr('tabindex',0);

        // Expand select only on tab, not on click
        $(document).keyup(function(e) {
            var key = (event.keyCode ? event.keyCode : event.which);
            if (key === 9) { // Tab key
                if(select.is(":focus")){
                    select.attr('size', select.find('option').length);
                } else {
                    select.on('focusout',function(){
                        select.attr('size', 1);
                    });
                }
            }
        });
    });



    //-----------------------------------------------------------------//
    // Add video attribute to video playlist as specified in our Elementor Videos Extension PHP class
    //-----------------------------------------------------------------//
    $(window).load(function(){
        $('.elementor-widget-video-playlist video').each(function(){
            $(this).attr('controlsList','nodownload noplaybackrate');
        });
    });

    // Detect if video can autoplay or not. When in battery save mode autoplay won't play. Handle that.
    // https://developer.chrome.com/blog/play-request-was-interrupted

    /*
    $('video.elementor-background-video-hosted, video.elementor-video').each(function(el){
        let video = $(this)[0];

        let playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.then(_ => {
                // All good, automatic playback started!
                if(video.classList.contains('elementor-background-video-hosted')){
                    video.style.opacity = '1';
                }
            })
                .catch(error => {
                    // Autoplay was prevented
                    if(error.toString().includes('NotAllowedError')){
                        console.log('video play error');

                        video.pause();
                        video.currentTime = 0;
                        video.removeAttribute('autoplay');
                        video.removeAttribute('loop');

                        // Check if video has a poster image (video players)
                        if(video.hasAttribute('poster')){
                            // Create a element on top of vide element
                            let poster = document.createElement('div');
                            poster.classList.add('video-fallback-poster');
                            poster.style.backgroundImage = 'url('+video.getAttribute('poster')+')';
                            poster.style.width = '100%';
                            poster.style.height = '100%';
                            poster.style.position = 'absolute';
                            poster.style.backgroundSize = 'cover';
                            poster.style.backgroundPosition = 'center';
                            video.parentNode.insertBefore(poster, video);
                        }

                        // If background video, use the Elementor fallback image instead and just hide the video player
                        if(video.classList.contains('elementor-background-video-hosted')){
                            //video.style.opacity = '0';
                        }
                    }

                });
        }

    });

     */







})(jQuery);
